import { ProductDocsAction, ProductsAction } from '../actions/types';
import { ProductDocsConstant, ProductsConstants } from '../constants';
import { arrayRemoveFirst, arrayReplaceFirst } from '../helpers';

export const initialList: STATES.ProductDocList = {
  isLoading: false,
  docs: [],
  total: 0,
  page: 0,
  refreshTrigger: 0,
  lastUploadedFileName: '',
};

export const initialState: STATES.ProductDocsState = {};

export const productDocs = (
  state = initialState,
  action: ProductDocsAction | ProductsAction
): STATES.ProductDocsState => {
  switch (action.type) {
    case ProductDocsConstant.GET_PRODUCT_DOCS_REQUEST: {
      const { documentType } = action.payload;

      const type = documentType || 'noFolder';

      return {
        ...state,
        [type]: {
          ...state[type],
          isLoading: true,
        },
      };
    }
    case ProductDocsConstant.GET_PRODUCT_DOCS_SUCCESS: {
      const {
        docs,
        total,
        documentType,
        page,
        filterCategory,
        searchTerm,
      } = action.payload;
      const type = documentType || 'noFolder';
      let newDoc: DTO.ProductDoc[];
      if (filterCategory?.length || searchTerm || page === 1) {
        newDoc = docs;
      } else {
        newDoc = [...(state[type].docs || []), ...docs];
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          page,
          docs: newDoc,
          total,
          isLoading: false,
        },
      };
    }
    case ProductDocsConstant.GET_PRODUCT_DOCS_FAILURE: {
      const { documentType } = action.payload;

      const type = documentType || 'noFolder';

      return {
        ...state,
        [type]: {
          ...state[type],
          isLoading: false,
        },
      };
    }
    case ProductDocsConstant.MOVE_PRODUCT_DOCS_REQUEST: {
      const { targetDocumentType, sourceDocumentType } = action.payload;

      return {
        ...state,
        [targetDocumentType || 'noFolder']: {
          ...state[targetDocumentType || 'noFolder'],
          isLoading: true,
        },
        [sourceDocumentType || 'noFolder']: {
          ...state[sourceDocumentType || 'noFolder'],
          isLoading: true,
        },
      };
    }
    case ProductDocsConstant.MOVE_PRODUCT_DOCS_FAILURE:
    case ProductDocsConstant.MOVE_PRODUCT_DOCS_SUCCESS: {
      const { targetDocumentType, sourceDocumentType } = action.payload;

      return {
        ...state,
        [targetDocumentType || 'noFolder']: {
          ...state[targetDocumentType || 'noFolder'],
          refreshTrigger:
            state[targetDocumentType || 'noFolder'].refreshTrigger + 1,
          isLoading: false,
        },
        [sourceDocumentType || 'noFolder']: {
          ...state[sourceDocumentType || 'noFolder'],
          refreshTrigger:
            (state[sourceDocumentType || 'noFolder'].refreshTrigger || 0) + 1,
          isLoading: false,
        },
      };
    }
    case ProductDocsConstant.ADD_DOCUMENT_SUCCESS: {
      const { documentType, filename } = action.payload;
      const type = documentType || 'noFolder';

      return {
        ...state,
        [type]: {
          ...state[type],
          refreshTrigger: state[type].refreshTrigger + 1,
          lastUploadedFileName: filename,
        },
      };
    }
    case ProductDocsConstant.DELETE_DOC_SUCCESS: {
      const { fileName, documentType } = action.payload;

      return {
        ...state,
        [documentType || 'noFolder']: {
          ...state[documentType || 'noFolder'],
          docs: arrayRemoveFirst(
            state[documentType || 'noFolder'].docs,
            doc => doc.fileName === fileName
          ),
          refreshTrigger: state[documentType || 'noFolder'].refreshTrigger + 1,
        },
      };
    }
    case ProductDocsConstant.DOCUMENT_LIST_RESET: {
      const { type } = action.payload;

      return {
        ...state,
        [type]: {
          ...state[type],
          ...initialList,
        },
      };
    }
    case ProductDocsConstant.UPDATE_DOC_FAVORITE_SUCCESS: {
      const { fileName, documentType, favorite } = action.payload;

      return {
        ...state,
        [documentType]: {
          ...state[documentType],
          docs: arrayReplaceFirst(
            state[documentType].docs,
            docs => docs.fileName === fileName,
            docs => ({
              ...docs,
              isStared: favorite,
            })
          ),
        },
      };
    }
    case ProductDocsConstant.CREATE_SECTION_SUCCESS: {
      const { documentType } = action.payload;

      return {
        ...state,
        [documentType]: initialList,
      };
    }
    case ProductDocsConstant.UPDATE_SECTION_SUCCESS: {
      const { oldDocumentType, newDocumentType } = action.payload;

      let tempState = state;
      if (oldDocumentType === newDocumentType) {
        const oldDocList = tempState[oldDocumentType];
        delete tempState[oldDocumentType];
        tempState = {
          ...tempState,
          [newDocumentType]: {
            ...oldDocList,
            refreshTrigger: oldDocList.refreshTrigger + 1,
          },
        };
      } else {
        delete tempState[oldDocumentType];
        tempState = {
          ...tempState,
          [newDocumentType]: initialList,
        };
      }
      return {
        ...tempState,
      };
    }
    case ProductDocsConstant.DELETE_SECTION_SUCCESS: {
      const { documentType } = action.payload;

      const tempState = state;
      delete tempState[documentType];

      return {
        ...tempState,
      };
    }
    case ProductsConstants.GET_PRODUCT_DETAIL_SUCCESS: {
      const { product } = action.payload;

      if (product && product.sections) {
        const tempState = initialState;
        product.sections.forEach(item => {
          tempState[item.name] = initialList;
        });

        return {
          ...tempState,
        };
      }

      return state;
    }
    case ProductDocsConstant.DOWNLOAD_PRODUCT_DOCS_REQUEST: {
      const { documentType } = action.payload;

      return {
        ...state,
        [documentType]: {
          ...state[documentType],
          isLoading: true,
        },
      };
    }
    case ProductDocsConstant.DOWNLOAD_PRODUCT_DOCS_FAILURE:
    case ProductDocsConstant.DOWNLOAD_PRODUCT_DOCS_SUCCESS: {
      const { documentType } = action.payload;

      return {
        ...state,
        [documentType]: {
          ...state[documentType],
          isLoading: false,
        },
      };
    }
    case ProductDocsConstant.RESET_LAST_UPLOADED_REQUEST: {
      const { sectionName } = action.payload;

      return {
        ...state,
        [sectionName]: {
          ...state[sectionName],
          lastUploadedFileName: '',
        },
      };
    }
    default:
      return state;
  }
};
